import { RichText, Text } from "@engaging-tech/components"
import React from "react"

import { parseRichText } from "../utils/richText"
import SurveyCard from "./surveyCard"

const CustomIntro = ({
  cardKey,
  title,
  richTitle,
  description,
  richDescription,
  isFirstSection,
  onNext,
  onPrevious
}) => {
  const parsedRichDescription = parseRichText(richDescription)
  const displayDescription = richDescription ?? description

  const renderDescription = () => {
    if (parsedRichDescription) {
      return <RichText value={parsedRichDescription} openLinksInNewTab />
    }

    if (typeof displayDescription === "string") {
      return <Text>{displayDescription}</Text>
    }

    return displayDescription?.map((item, index) => (
      <Text
        // eslint-disable-next-line react/no-array-index-key
        key={index}
        mb={index === displayDescription.length - 1 ? 0 : 3}
        display="block"
      >
        {item.content}
      </Text>
    ))
  }

  return (
    <SurveyCard
      key={cardKey}
      title={title}
      richTitle={richTitle}
      onNext={onNext}
      onPrevious={onPrevious}
      isFirstSection={isFirstSection}
      isIntro
    >
      {renderDescription()}
    </SurveyCard>
  )
}

export default CustomIntro
